﻿/* Captcha ALTCHA */
//import "altcha";
require("altcha");